module.exports = __webpack_public_path__ + "img/g2-en.6875b783.jpeg";